import { validateDate } from "./validateDate";
import { format } from "date-fns";

export const getTableDateTime = (date: string | undefined | Date | null) =>
  date && validateDate(date)
    ? format(
        typeof date === "string" ? new Date(date) : date,
        "MMM d, yyyy h:mm aa",
      )
    : "";
